import { TUserRoleEnum } from "@domain/interface/User";
import { IUserService } from "@domain/services/IUserService";
import { IImpersonationService } from "@domain/services/IImpersonationService";
import { FamilyRepository } from "@infrastructure/repositories/family-repository";

export class FindFamiliesByTenantUseCase {
  constructor(
    private readonly familyRepository: FamilyRepository,
    private readonly userService: IUserService,
    private readonly impersonationService: IImpersonationService
  ) {}

  public async execute(status?: "ALL" | "ACTIVE" | "INACTIVE") {
    const isRole = (role: TUserRoleEnum) => {
      return this.userService.user?.roles.includes(role);
    };

    const currentTenant = isRole("SUPER_ADMIN")
      ? this.impersonationService.persistedState?.impersonatedTenant ?? ""
      : this.userService.user?.tenantId ?? "";

    return await this.familyRepository.getByTenant({ tenantId: currentTenant, fullDTO: false, status: status ?? "ACTIVE" });
  }
}
